@if (isAdmin()) {
    <aside
        class="sidebar"
        [class.sidebar-mobile]="sidebarService.isBelowTabletWidth()"
        [class.sidebar-wider]="sidebarService.isBelowTabletWidth()"
        [class.sidebar-hidden]="!sidebarService.isAdminSidebarEnabled()"
        [class.sidebar-fullscreen]="sidebarService.isBelowMobileWidth() && sidebarService.isAdminSidebarEnabled()"
        data-testid="admin-sidebar"
    >
        <section>
            <div class="sidebar-header">
                <img src="assets/icons/admin-filled.svg" alt="Burger Icon" />
                <img src="assets/icons/close-nav-cross.svg" alt="Burger Icon" class="sidebar-header-close" (click)="sidebarService.disableAdminSidebar()" data-testid="admin-sidebar-close-button" />
            </div>

            <nav class="nav">
                <div class="nav-title"><strong>Admin</strong></div>
                <a role="button" class="nav-link" id="nav-support" [routerLink]="['/admin/support']" data-testid="admin-sidebar-support-link">
                    <img src="assets/icons/nav-icons-black/support.svg" alt="transactions icon" />
                    <span>{{ "navbar.settings_support_tool" | translate }}</span>
                </a>

                <a role="button" class="nav-link" id="nav-monitor-health" [routerLink]="['/admin/monitor-health']" data-testid="admin-sidebar-monitor-health-link">
                    <img src="assets/icons/nav-icons-black/health-monitor.svg" alt="health-monitor icon" />
                    <span>{{ "operator.filter_bar.anton-health" | translate }}</span>
                </a>

                <a role="button" class="nav-link" id="nav-discount-tool" [routerLink]="['/admin/discount-tool']" data-testid="admin-sidebar-discount-tool-link">
                    <img src="assets/icons/nav-icons-black/discount.svg" alt="discount icon" />
                    <span>{{ "discount_tool.discount_tool" | translate }}</span>
                </a>
            </nav>

            <div class="divider"></div>

            <div class="control-tooltip">
                <p>What can I control?</p>
                <app-aw-tooltip tooltipTitle="Control Options">
                    <div description class="control-tooltip-options">
                        <!--Customer-->
                        <p><i>Type</i></p>
                        <p><i>Examples</i></p>
                        <p></p>
                        <p></p>
                        <!--Customer-->
                        <p>Customer:</p>
                        <p>JR11uLuOc0Wy8C36YXGqOz4khCt2</p>
                        <!--Stripe-->
                        <p>Stripe Acc:</p>
                        <p>acct_1Q5LOwRgF3OlxFAA</p>
                        <!--Location-->
                        <p>Location:</p>
                        <p>-OIvAY2qL7drENU_Kyxk</p>
                        <!--Device-->
                        <p>Device:</p>
                        <p>AW12345678R1</p>
                        <!--Terminal-->
                        <p>Terminal:</p>
                        <p>WPC123456789012</p>
                        <!--Terminal-->
                        <p>User:</p>
                        <p>5XW5NaStvLWWuBGvkSMMv1a9haJ3</p>
                    </div>
                </app-aw-tooltip>
            </div>
            <div class="control-input" cdkOverlayOrigin #origin="cdkOverlayOrigin">
                <input
                    #controlledInput
                    type="text"
                    class="form-control control-input-field"
                    placeholder="Control..."
                    (keyup.enter)="enterControlledState(controlledInput.value)"
                    (focus)="setControlHistory(true)"
                    (blur)="setControlHistory(false)"
                    data-testid="admin-sidebar-control-input"
                />
                <div class="control-input-append" (click)="enterControlledState(controlledInput.value)" data-testid="admin-sidebar-control-submit-button">
                    <img src="assets/icons/admin-white.svg" alt="Admin logo" />
                </div>
            </div>

            <ng-template
                cdkConnectedOverlay
                cdkConnectedOverlayPanelClass="admin-control-history-pane"
                [cdkConnectedOverlayOrigin]="origin"
                [cdkConnectedOverlayOpen]="adminService.controlHistoryOpened()"
                [cdkConnectedOverlayPositions]="[{ originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetX: 0, offsetY: 0 }]"
                [cdkConnectedOverlayWidth]="sidebarService.isBelowMobileWidth() ? origin.elementRef.nativeElement.offsetWidth : null"
            >
                <section class="control-history-section" (mousedown)="$event.preventDefault()">
                    @if (controlHistory().length > 0) {
                        <table>
                            <p>Recently controlled</p>
                            <tr>
                                <th>Time</th>
                                <th>Type</th>
                                <th>Name</th>
                                <th>Identifier</th>
                                <th></th>
                            </tr>
                            @for (historyEntry of controlHistory() | paginate: pageSize : pageNumber; track $index; let i = $index) {
                                <tr [attr.data-testid]="'admin-sidebar-control-history-row-' + historyEntry.search_key">
                                    <td (click)="enterControlledState(historyEntry.search_key)">{{ helperService.getSmartDate(historyEntry.timestamp) }}</td>
                                    <td (click)="enterControlledState(historyEntry.search_key)">{{ historyEntry.type ? historyEntry.type.charAt(0).toUpperCase() + historyEntry.type.slice(1) : "" }}</td>
                                    <td (click)="enterControlledState(historyEntry.search_key)">{{ historyEntry.name }}</td>
                                    <td (click)="enterControlledState(historyEntry.search_key)" [id]="historyEntry.search_key + i">{{ historyEntry.search_key }}</td>
                                    <td>
                                        <img
                                            src="assets/icons/copy-icon.svg"
                                            class="info-box-value-copy"
                                            alt="copy"
                                            (click)="helperService.copySomeText(historyEntry.search_key, historyEntry.search_key + i)"
                                            [attr.data-testid]="'admin-sidebar-control-history-row-' + historyEntry.search_key + '-copy-button'"
                                        />
                                    </td>
                                </tr>
                            }
                        </table>
                        <mat-paginator [length]="controlHistory().length" [pageSize]="pageSize" [pageIndex]="pageNumber" [showFirstLastButtons]="true" (page)="handlePage($event)" />
                    } @else {
                        <div class="no-history">
                            @if (loadingControlHistory()) {
                                <app-loading-indicator size="tiny" color="secondary" />
                            } @else {
                                <p>No control history found</p>
                            }
                        </div>
                    }
                </section>
            </ng-template>

            <nav class="nav">
                <a role="button" class="nav-link" (click)="exitControlledState()" data-testid="admin-sidebar-end-session-link">
                    <img src="assets/icons/nav-icons-black/log-out.svg" alt="log-out icon" />
                    <span>End session</span>
                </a>
            </nav>

            <div class="divider"></div>

            <div class="info">
                @if (adminService.loadingControlledUid()) {
                    <app-loading-indicator size="small" color="secondary" />
                } @else if (adminService.controlActive() && controlledUser) {
                    <!-------------------- MEMBER -------------------->
                    <h4 class="info-header">Member:</h4>

                    <!-- User UID -->
                    <div class="info-box">
                        <p><strong>UID:</strong></p>
                        <div class="info-box-value">
                            <p [id]="authenticatedUser.uid + '-member'">{{ authenticatedUser.uid }}</p>
                            <img
                                src="assets/icons/copy-icon.svg"
                                class="info-box-value-copy"
                                alt="copy"
                                (click)="helperService.copySomeText(authenticatedUser.uid, authenticatedUser.uid + '-member')"
                                data-testid="admin-sidebar-member-uid-copy-button"
                            />
                        </div>
                    </div>

                    <!-- User Role -->
                    <div class="info-box">
                        <p><strong>Role:</strong></p>
                        <div class="info-box-value">
                            <p [id]="authenticatedUser.role">{{ authenticatedUser.role }}</p>
                            <img
                                src="assets/icons/copy-icon.svg"
                                class="info-box-value-copy"
                                alt="copy"
                                (click)="helperService.copySomeText(authenticatedUser.role.toString(), authenticatedUser.role.toString())"
                                data-testid="admin-sidebar-member-role-copy-button"
                            />
                        </div>
                    </div>

                    <!-- User Email -->
                    <div class="info-box">
                        <p><strong>Email:</strong></p>
                        <div class="info-box-value">
                            <p [id]="authenticatedUser.email + '-member'">{{ authenticatedUser.email }}</p>
                            <img
                                src="assets/icons/copy-icon.svg"
                                class="info-box-value-copy"
                                alt="copy"
                                (click)="helperService.copySomeText(authenticatedUser.email, authenticatedUser.email + '-member')"
                                data-testid="admin-sidebar-member-email-copy-button"
                            />
                        </div>
                    </div>

                    <!-- MFA Enrollment -->
                    <div class="info-box">
                        <p><strong>MFA:</strong></p>
                        <div class="info-box-value">
                            <p [id]="mfaEnrollments + '-member'">{{ mfaEnrollments ?? "-" }}</p>
                        </div>
                    </div>

                    <div class="divider"></div>

                    <!-------------------- LOCATION -------------------->
                    @if (adminService.controlledLocation()) {
                        <div [class.not-on-location]="!isOnControlledLocation()">
                            <div class="info-header-box">
                                <h4>Location:</h4>
                                <div>
                                    <u (click)="goToLocation()" data-testid="admin-sidebar-go-to-location-link">Go -></u>
                                </div>
                            </div>

                            <div class="info-box">
                                <p><strong>Location ID:</strong></p>
                                <div class="info-box-value">
                                    <p [id]="adminService.controlledLocation().search_key">{{ adminService.controlledLocation().search_key }}</p>
                                    <img
                                        src="assets/icons/copy-icon.svg"
                                        class="info-box-value-copy"
                                        alt="copy"
                                        (click)="helperService.copySomeText(adminService.controlledLocation().search_key, adminService.controlledLocation().search_key)"
                                        data-testid="admin-sidebar-location-id-copy-button"
                                    />
                                </div>
                            </div>

                            <div class="info-box-value">
                                <p><strong>Ark:</strong></p>
                                <p>{{ adminService.controlledLocation().hasArk }}</p>
                            </div>

                            <div class="info-box-value">
                                <p><strong>Boost:</strong></p>
                                <p>{{ adminService.controlledLocation().hasBoost }}</p>
                            </div>

                            <div class="info-box-value">
                                <p><strong>Booking:</strong></p>
                                <p>{{ adminService.controlledLocation().hasBooking }}</p>
                            </div>

                            <div class="info-box-value">
                                <p><strong>Coupons:</strong></p>
                                <p>{{ adminService.controlledLocation().hasCoupons }}</p>
                            </div>

                            <div class="info-box-value">
                                <p><strong>Terminals:</strong></p>
                                <p>{{ adminService.controlledLocation().hasTerminals }}</p>
                            </div>

                            <div class="info-box-value">
                                <p><strong>Hubs:</strong></p>
                                <p>{{ adminService.controlledLocation().hasHubs }}</p>
                            </div>

                            <div class="info-box-value">
                                <p><strong>Axels:</strong></p>
                                <p>{{ adminService.controlledLocation().hasAxels }}</p>
                            </div>

                            <div class="info-box-value">
                                <p><strong>Credit users:</strong></p>
                                <p>{{ adminService.controlledLocation().hasCreditUsers }}</p>
                            </div>
                        </div>

                        <div class="divider"></div>
                    }

                    <!-------------------- CUSTOMER -------------------->
                    <h4 class="info-header">Owner:</h4>

                    <!-- UID -->
                    <div class="info-box">
                        <p><strong>UID:</strong></p>
                        <div class="info-box-value">
                            <p [id]="dashboardOwnerUser.uid">{{ dashboardOwnerUser.uid }}</p>
                            <img
                                src="assets/icons/copy-icon.svg"
                                class="info-box-value-copy"
                                alt="copy"
                                (click)="helperService.copySomeText(dashboardOwnerUser.uid, dashboardOwnerUser.uid)"
                                data-testid="admin-sidebar-owner-uid-copy-button"
                            />
                        </div>
                    </div>

                    <!-- is operator-->
                    <div class="info-box-value">
                        <p><strong>Operator:</strong></p>
                        <p>{{ controlledUser.ownerClaims.operator ?? false }}</p>
                    </div>

                    <!-- Operator UID -->
                    <div class="info-box">
                        <p><strong>Operator UID:</strong></p>
                        <div class="info-box-value">
                            <p [id]="operatorUID()">{{ operatorUID() }}</p>
                            @if (operatorUID() !== "N/A") {
                                <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(operatorUID(), operatorUID())" data-testid="admin-sidebar-operator-uid-copy-button" />
                            }
                        </div>
                    </div>

                    <!-- Email-->
                    <div class="info-box">
                        <p><strong>Email:</strong></p>
                        <div class="info-box-value">
                            <p [id]="controlledUser.email">{{ controlledUser.email }}</p>
                            <img src="assets/icons/copy-icon.svg" class="info-box-value-copy" alt="copy" (click)="helperService.copySomeText(controlledUser.email, controlledUser.email)" data-testid="admin-sidebar-owner-email-copy-button" />
                        </div>
                    </div>

                    <!-- AccID-->
                    <div class="info-box">
                        <p><strong>AccID::</strong></p>
                        <div class="info-box-value">
                            <p [id]="controlledUser.account_id">{{ controlledUser.account_id }}</p>
                            <img
                                src="assets/icons/copy-icon.svg"
                                class="info-box-value-copy"
                                alt="copy"
                                (click)="helperService.copySomeText(controlledUser.account_id, controlledUser.account_id)"
                                data-testid="admin-sidebar-owner-account-id-copy-button"
                            />
                        </div>
                    </div>
                    <!-- CustID-->
                    <div class="info-box">
                        <p><strong>CustID:</strong></p>
                        <div class="info-box-value">
                            <p [id]="controlledUser.billing?.stripe_customer_id">{{ controlledUser.billing?.stripe_customer_id ?? "N/A" }}</p>
                            @if (controlledUser.billing?.stripe_customer_id) {
                                <img
                                    src="assets/icons/copy-icon.svg"
                                    class="info-box-value-copy"
                                    alt="copy"
                                    (click)="helperService.copySomeText(controlledUser.billing.stripe_customer_id, controlledUser.billing.stripe_customer_id)"
                                    data-testid="admin-sidebar-owner-stripe-customer-id-copy-button"
                                />
                            }
                        </div>
                    </div>
                    <!-- Economic-->
                    <div class="info-box">
                        <p><strong>Economic:</strong></p>
                        <div class="info-box-value">
                            <p [id]="controlledUser.billing?.economic_customer_number">{{ controlledUser.billing?.economic_customer_number ?? "N/A" }}</p>
                            @if (controlledUser.billing?.economic_customer_number) {
                                <img
                                    src="assets/icons/copy-icon.svg"
                                    class="info-box-value-copy"
                                    alt="copy"
                                    (click)="helperService.copySomeText(controlledUser.billing.economic_customer_number, controlledUser.billing.economic_customer_number)"
                                    data-testid="admin-sidebar-owner-economic-customer-number-copy-button"
                                />
                            }
                        </div>
                    </div>
                    <!-- Located-->
                    <div class="info-box">
                        <p><strong>Located:</strong></p>
                        <div class="info-box-value">
                            <p [id]="regionCountry()">{{ regionCountry() }}</p>
                        </div>
                    </div>

                    <div class="divider"></div>
                    <!-------------------- PLAN -------------------->
                    <h4 class="info-header">Plan:</h4>

                    <!-- Billing interval-->
                    <div class="info-box-value">
                        <p><strong>Billing interval:</strong></p>
                        <p [id]="controlledUser.subscriptionPlanInterval">{{ controlledUser.subscriptionPlanInterval !== 0 ? controlledUser.subscriptionPlanInterval + " months" : "N/A" }}</p>
                    </div>
                    <!-- Price-->
                    <div class="info-box-value">
                        <p><strong>Price:</strong></p>
                        <p [id]="controlledUser.price">{{ controlledUser?.price ? helperService.getPrice(controlledUser.price) : "N/A" }}</p>
                    </div>
                    <!-- VAT Verified-->
                    <div class="info-box-value">
                        <p><strong>VAT Number:</strong></p>
                        <p [id]="controlledUser.vat_number">
                            <span>
                                {{ controlledUser.vat_number ?? "N/A" }}
                                @if (controlledUser.vat_number) {
                                    <img class="info-box-value-check" src="assets/icons/{{ controlledUser.vat_verified ? 'check-circle' : 'cross' }}.svg" alt="Check icon" />
                                }
                            </span>
                        </p>
                    </div>
                    <!-- Plan-->
                    <div class="info-box-value">
                        <p><strong>Plan:</strong></p>
                        <p [id]="controlledUser.subscriptionPlanType">{{ controlledUser.subscriptionPlanType }}</p>
                    </div>
                    <!-- Additional Access-->
                    @if (controlledUser.additionalAccess) {
                        <div class="info-box-value">
                            <p><strong>Additional:</strong></p>
                            <p [id]="controlledUser.additionalAccess">{{ controlledUser.additionalAccess ? "Yes" : "No" }}</p>
                        </div>
                    }
                    <!-- Exclude Access-->
                    @if (controlledUser.excludeAccess) {
                        <div class="info-box-value">
                            <p><strong>Exclude:</strong></p>
                            <p [id]="controlledUser.excludeAccess">{{ controlledUser.excludeAccess ? "Yes" : "No" }}</p>
                        </div>
                    }
                }
            </div>
        </section>
        <section class="end">
            <nav class="nav"></nav>
        </section>
    </aside>
}
